const isOfType = <T>(value: any, property: keyof T): value is T =>
  (value as T)[property] !== undefined;

export { isOfType };
